import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { ModalService } from '../shared/modal/modal.service';
import { GlobalService } from '../services/global.service';
import { PagerService } from '../services/pager.service';
import { LoadingService } from '../shared/loading/loading.service';

import { Client } from '../models/client';

import Utility from '../shared/utility';

@Component({
  selector: 'app-client',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  public clients: any[] = [];
  public error: string;
  public role: number;

  public screenWidth: number = window.innerWidth;

  private allItems: any[];
  pager: any = {};
  pagedItems: any[];

  private filteredClients: any;
  public modalSubscription;

  activeFirstNameArrow: boolean;
  activeOrgNameArrow: boolean;
  activeAdvisorNameArrow: boolean;
  activeDateArrow: boolean;

  constructor(private modalService: ModalService, private globalService: GlobalService, private pagerService: PagerService, private loadingService: LoadingService, private router: Router) {
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      // console.log("Ran in subscription");
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        // console.log('modal closed woo!');
        this.getClients();
        modal.data = {};
      }
    });
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  ngOnInit() {
    // console.log("Ran onInit");
    this.role = Number(localStorage.getItem('roleId'));
    this.getClients();
    
  }

  getClients() {
    this.loadingService.isLoading(true);
    this.globalService.getClientsData()
        .subscribe(
            clients => {
              var spouses;
              // console.log(clients);

              this.allItems = clients.map((item) => { 
                spouses = JSON.parse(item.cp.Spouses) || [];

                if (item.c) {
                  item.c.OrganizationName = item.o ? item.o.Name : '';
                  
                  spouses.map((spouse) => {
                    if (spouse && spouse.maritalStatus == 'Married') {
                      item.c.spouseName = spouse.firstName + " " + spouse.lastName;
                    }
                  });

                  if (item.a) {
                    item.c.AdvisorName = item.a.FirstName + " " + item.a.LastName;
                    item.c.AdvisorID = item.a.ID;
                    item.c.AdvisorOrgID = item.a.OrganizationID;
                  }
                  
                  return item.c;
                } else {
                  return item
                }                
              });

              // console.log(this.allItems);


              // console.log(this.allItems);
              this.filteredClients = this.allItems;

              this.filteredClients = this.allItems.sort(function(a, b) {
                return parseInt(b.ID) - parseInt(a.ID);
              });
              this.setPage(1);
              this.loadingService.isLoading(false);

              // console.log(clients);
              // console.log(this.allItems);
              // console.log(this.filteredClients);
              // console.log(this.pagedItems);

            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
            });
  }

  

  setPage(page: number) {
    // this.disableAllSortArrow();
    if (this.filteredClients.length === 1) {
      this.pagedItems = this.filteredClients;
      this.pager = this.pagerService.getPager(this.filteredClients.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
        return;
    }

    // get pager object from service
    // this.pager = this.pagerService.getPager(this.allItems.length, page);
    this.pager = this.pagerService.getPager(this.filteredClients.length, page);

    // get current page of items
    this.pagedItems = this.filteredClients.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  handleCreateClientModal(e) {
    this.modalService.add('add-edit-client', { ID: 0 });
  }

  handleEditClientModal(e, client) {
    if ((Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2))
      this.modalService.add('add-edit-client', { ID: client.ID, AdvisorID: client.AdvisorID, AdvisorOrgID: client.AdvisorOrgID });
    else
      this.modalService.add('add-edit-client', { ID: client.ID });
  }

  handleCreateReport(e, client) {
    localStorage.setItem('selectedClient', client.ID);
    localStorage.setItem('selectedAdvisor', client.AdvisorName);
    localStorage.setItem('selectedAdvisorID', client.AdvisorID);
    localStorage.setItem('selectedAdvisorOrgID', client.AdvisorOrgID);
    this.router.navigate(['reports/create']);
  }

  assignCopy(){
    this.filteredClients = Object.assign([], this.allItems);
  }

  filterItem(value){
      this.filteredClients = Object.assign([], this.allItems).filter(
        advisor => {
          return (advisor.FirstName + " " + advisor.LastName + " " + advisor.spouseName).toLowerCase().includes(value.toLowerCase()) || (advisor.AdvisorName).toLowerCase().includes(value.toLowerCase()) || (advisor.OrganizationName).toLowerCase().includes(value.toLowerCase())
        }
      );
      
      if (!this.filteredClients.length) {
        this.pagedItems = [];
      } else {
        this.setPage(1);
      }
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' +  Utility.parseDateTime(date) : '--';
  }

  disableAllSortArrow() {
    this.activeFirstNameArrow = false;
    this.activeOrgNameArrow = false;
    this.activeAdvisorNameArrow = false;
    this.activeDateArrow = false;
  }

  private isColSortedAsc: any = {
    FirstName: false,
    OrganizationName: false,
    AdvisorName: false,
  }
  
  sort(colName) {
    this.disableAllSortArrow();
    if (colName == 'FirstName') {
      this.filteredClients.sort((a, b) => this.isColSortedAsc[colName] ? (a.FirstName.trim() + a.LastName).localeCompare(b.FirstName.trim() + b.LastName) : (b.FirstName + b.LastName).localeCompare(a.FirstName.trim() + a.LastName));
      this.setPage(this.pager.currentPage);
      this.activeFirstNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'OrganizationName') {
      this.filteredClients.sort((a, b) => this.isColSortedAsc[colName] ? a.OrganizationName.localeCompare(b.OrganizationName ) : b.OrganizationName.localeCompare(a.OrganizationName ));
      this.setPage(this.pager.currentPage);
      this.activeOrgNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'AdvisorName') {
      this.filteredClients.sort((a, b) => this.isColSortedAsc[colName] ? a.AdvisorName.trim().localeCompare(b.AdvisorName.trim()) : b.AdvisorName.trim().localeCompare(a.AdvisorName.trim()));
      this.setPage(this.pager.currentPage);
      this.activeAdvisorNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'Date') {
      this.filteredClients.sort((a, b) => this.isColSortedAsc[colName] ? Date.parse(a.CreatedDate) - Date.parse(b.CreatedDate) : Date.parse(b.CreatedDate) - Date.parse(a.CreatedDate));
      this.setPage(this.pager.currentPage);
      this.activeDateArrow = this.isColSortedAsc[colName];
    }

    this.isColSortedAsc[colName] = !this.isColSortedAsc[colName];
  }
}
